


















































import Vue from 'vue';
import { find, includes, isArray } from 'lodash';
import { VBTooltip } from 'bootstrap-vue';

import ZenMultiselect from '@reciprocity/multiselect';
import { getTooltipOptions, getPersonFullLabel } from '@/components/tooltips/utils';

import { DropdownOption } from '@/components/cards/types';

const getRawValue = (input?: DropdownOption) => (input ? input.value : null);

export interface Option {
  value: string;
  label: string;
}

export default Vue.extend({
  name: 'EditCardDropdown',
  components: {
    ZenMultiselect,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    subtype: {
      type: String,
      default: 'single',
    },
    showZeroOption: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Array],
      default: '',
    },
    preselectFirst: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newTags: <DropdownOption[]>[],
    };
  },
  computed: {
    allOptions(): DropdownOption[] {
      return this.options.concat(this.newTags);
    },
    deselectLabel(): string | undefined {
      const singleSelection = this.subtype === 'single';
      const lastInMultiSelection = this.multiple && this.value && this.value.length < 2;

      return this.required && (singleSelection || lastInMultiSelection) ? "Can't remove this value" : undefined;
    },
    taggable(): boolean {
      return this.subtype === 'tags';
    },
    multiple(): boolean {
      return includes(['multi', 'tags'], this.subtype);
    },
    fullValue(): DropdownOption | DropdownOption[] {
      const findFullValue = (value: string): DropdownOption => find(this.allOptions, { value });

      return isArray(this.value) ? (this.value as string[]).map(findFullValue) : findFullValue(this.value as string);
    },
    placeholderDisplay(): string {
      if (this.placeholder) {
        return this.placeholder;
      } else if (this.taggable) {
        return 'Type to search for existing tags or create a new tag';
      } else if (this.multiple) {
        return 'Select one or more options';
      } else {
        return 'Select option';
      }
    },
    isPersonDropdown(): boolean {
      return !!this.options.find(o => !!o.role);
    },
  },
  methods: {
    addTag(newTag: string) {
      this.newTags.push({ value: newTag, label: newTag });
      const value = this.value ? (Array.isArray(this.value) ? this.value : [this.value]) : [];
      this.$emit('input', value.concat([newTag]));
    },
    makeSelection(newValue: DropdownOption | DropdownOption[]): void {
      const newRawValue = isArray(newValue) ? newValue.map(getRawValue) : getRawValue(newValue);

      this.$emit('input', newRawValue);
    },
    getTooltipOptions,
    getPersonFullLabel,
  },
});
